const agentSetupActionTypes = {
  AGENT_FETCH_DOWNLOAD_REQUEST: 'AGENT_FETCH_DOWNLOAD_REQUEST',
  AGENT_FETCH_DOWNLOAD_FAILURE: 'AGENT_FETCH_DOWNLOAD_FAILURE',
  AGENT_FETCH_DOWNLOAD_SUCCESS: 'AGENT_FETCH_DOWNLOAD_SUCCESS',
};

export default agentSetupActionTypes;
